import { render, staticRenderFns } from "./Ephemera.vue?vue&type=template&id=5cae11ac&scoped=true&"
import script from "./Ephemera.vue?vue&type=script&lang=js&"
export * from "./Ephemera.vue?vue&type=script&lang=js&"
import style0 from "./Ephemera.vue?vue&type=style&index=0&id=5cae11ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae11ac",
  null
  
)

export default component.exports